import { createAction } from '@ngrx/store';

export const TabIndexChange = createAction('[Merchant: Details]: Tab Index Change');

export const ResetTabIndex = createAction('[Merchant: Details]: Reset Tab Index');

export const ReloadMerchantDetailsData = createAction(
  '[Merchant: Details]: Reload Merchant Details Data',
);
